/* eslint-disable */
import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Header, Container, ExportReportWrapper } from '../../styles/shared/styles';
import Box from '@material-ui/core/Box';
import DatePeriodFilter from '../../components/RenovationReport/Filter';
import SummaryReport from '../../components/RenovationReport/SummaryReport';
import useSWR from 'swr';
import { fetcher } from '../../service/SWRFetcher';
import useApp from '../../hooks/useApp';
import { DateTime } from 'luxon';
import { TablePagination } from '@material-ui/core';
import { listToMatrix } from '../../utils/array';
import { excelExport } from '../../service/excel.service';
import RenovationReportTableList from '../../components/RenovationReport';

const RenovationReport = () => {
  const { lead_states, lead_sold, lead_status, lead_lost_sale, setState } = useApp();
  const [userId, setUserId] = useState();

  const [totalLeads, setTotalLeads] = useState([]);
  const [leads, setLeads] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [summary, setSummary] = useState([]);

  const [filters, setFilters] = useState({
    per_page: 10,
    page: 0,
  });

  const [reportFilter, setReportFilter] = useState({
    date_ini: DateTime.now().plus({ months: -1 }).toISODate(),
    date_end: DateTime.now().toISODate(),
    client: '',
    channel_id: '',
    broker_id: '',
    paginate: null,
  });

  const handleChangePage = (event, newPage) => {
    setFilters({ ...filters, page: newPage });
  };
  const handleChangeRowsPerPage = (event) => {
    setFilters({ ...filters, page: 0, per_page: parseInt(event.target.value) });
    mutate();
  };

  const brokerFilter = () => {
    if (!reportFilter.broker_id || reportFilter.broker_id.length === 0) return '';

    let stringBrokerFilter = '';
    reportFilter.broker_id.map((broker) => (stringBrokerFilter += `&broker_id[]=${broker.id}`));
    return stringBrokerFilter;
  };

  const channelFilter = () => {
    if (!reportFilter.channel_id || reportFilter.channel_id.length === 0) return '';

    let stringChannelFilter = '';
    reportFilter.channel_id.map((channel) => (stringChannelFilter += `&channel_id[]=${channel.id}`));
    return stringChannelFilter;
  };

  const { data, mutate, isValidating } = useSWR(
    `/leads/renovationReport?date_ini=${reportFilter.date_ini}&date_end=${
      reportFilter.date_end
    }${brokerFilter()}${channelFilter()}&client_name=${reportFilter.client}`,
    fetcher,
    { revalidateOnFocus: false }
  );

  useEffect(() => {
    if (data?.length > 2 && !isValidating) {
      const leadsMatrix = listToMatrix(data[0], filters.per_page);
      setTotalLeads(leadsMatrix);
      setTotalPages(leadsMatrix.length);
      setLeads(leadsMatrix[filters.page]);
      setSummary(data[1]);
    }
  }, [data, isValidating]);

  useEffect(() => {
    setLeads(totalLeads[filters.page]);
  }, [filters.page]);

  useEffect(() => {
    setState('loading', isValidating);
  }, [isValidating]);

  return (
    <>
      <motion.div initial={{ opacity: 0, x: -100 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -100 }}>
        <Container>
          <Header>
            <h1>Relatório de Renovações</h1>
          </Header>
          <DatePeriodFilter id={userId} filters={reportFilter} setFilters={setReportFilter} />
          <SummaryReport listItem={summary} title="Relatório de Renovações - Resumo" />

          {!!data && data[0]?.length > 0 && (
            <ExportReportWrapper>
              <button
                className="button"
                onClick={() =>
                  excelExport(
                    `/leads/summaryRenovationReportExport?date_ini=${reportFilter.date_ini}&date_end=${
                      reportFilter.date_end
                    }${brokerFilter()}${channelFilter()}&client_name=${filters.client}`,
                    'resumo_relatorio_renovacao' + DateTime.now().toFormat('dd_LL_yyyy')
                  )
                }>
                Exportar
              </button>
            </ExportReportWrapper>
          )}

          <Box m={5} />
          <TablePagination
            component="div"
            count={data ? data[0]?.length : 0}
            page={filters.page}
            onPageChange={handleChangePage}
            rowsPerPage={filters.per_page}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />

          <RenovationReportTableList
            listItem={leads}
            title="Relatório de Renovações"
            states={lead_states}
            sold={lead_sold}
            status={lead_status}
            lostSale={lead_lost_sale}
          />

          {!!data && data[0]?.length > 0 && (
            <ExportReportWrapper>
              <button
                className="button"
                onClick={() =>
                  excelExport(
                    `/leads/renovationReportExport?date_ini=${reportFilter.date_ini}&date_end=${
                      reportFilter.date_end
                    }${brokerFilter()}${channelFilter()}&client_name=${filters.client}`,
                    'relatorio_renovacao' + DateTime.now().toFormat('dd_LL_yyyy')
                  )
                }>
                Exportar
              </button>
            </ExportReportWrapper>
          )}
        </Container>
      </motion.div>
    </>
  );
};

export default RenovationReport;
